import { useT } from '@/i18n/useI18n';
import { PingIndicator } from '@/components/PingIndicator';

interface MatchTopBarProps {
  timer: number;
  combo: number;
  paused: boolean;
  onPause: () => void;
  onQuit: () => void;
}

export function MatchTopBar({ timer, combo, onQuit, onPause, paused }: MatchTopBarProps) {
  const t = useT();
  // `paused` / `onPause` are kept on the prop type so MatchScreen doesn't need
  // refactoring, but the in-match pause button is removed — pausing a 15-20s
  // race rarely helps the player and gives a way to dodge a losing position.
  void paused;
  void onPause;

  return (
    <div style={{ padding: '8px 14px 4px', display: 'flex', alignItems: 'center', gap: 8 }}>
      <button
        onClick={onQuit}
        style={{
          width: 32,
          height: 32,
          borderRadius: 10,
          background: 'rgba(0,0,0,0.5)',
          border: '1px solid var(--hairline)',
          color: 'var(--ink)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
        }}
        aria-label={t('match.quit_aria')}
      >
        ✕
      </button>

      <PingIndicator />

      <div
        className="mono"
        style={{
          flex: 1,
          textAlign: 'center',
          fontSize: 18,
          color: 'var(--c-cyan)',
          textShadow: '0 0 10px rgba(34,211,238,0.4)',
          fontFamily: 'var(--f-mono)',
          fontWeight: 700,
        }}
      >
        {timer.toFixed(1)}
        <span style={{ fontSize: 10, marginLeft: 2, color: 'var(--ink-dim)' }}>s</span>
      </div>

      {combo >= 3 ? (
        <div
          style={{
            padding: '4px 10px',
            borderRadius: 99,
            background: 'linear-gradient(180deg, var(--c-red), #b32432)',
            fontFamily: 'var(--f-display)',
            fontSize: 12,
            color: '#fff',
            boxShadow: '0 0 14px rgba(230,57,70,0.5), inset 0 1px 0 rgba(255,255,255,0.3)',
            animation: 'pulse-scale 0.5s ease-in-out infinite',
          }}
        >
          {t('match.combo', { n: combo })}
        </div>
      ) : (
        // Empty spacer keeps the timer optically centered when no combo badge.
        <div style={{ width: 32, height: 32 }} />
      )}
    </div>
  );
}
